import { getLang as getLangFlag, getOriginLang } from './lang';

/** 当前语言 */
let curLang: string = '';
/** 语言选择范围 */
let defaultSelectArr = ['zh-cn', 'zh-hk', 'en'];
/** 默认语言格式化选项 */
let defaultOption = {
  key: 'lang',
  defaultLang: 'en',
  keyMap: {
    // 台湾也和繁体中文一样处理
    'zh-tw': () => 'zh-hk',
  },
};

/**
 * 设置语言
 * @param lang 语言标识，如 zh-hk、en
 * @param selectArr 语言选择范围
 * @param option 语言格式化选项
 */
function setLanguage(
  lang = '',
  selectArr = defaultSelectArr,
  option = defaultOption
): void {
  curLang = lang;
  defaultSelectArr = selectArr;
  defaultOption = Object.assign({}, defaultOption, option);
}

/**
 * 指定的语言转换规则获取语言标识
 * @param selectArr 指定的语言标识范围 如：['zh-hk', 'en']
 * @param option 语言格式化选项
 * @returns 返回语言标识，如 zh-hk、en
 */
function getLang(selectArr = defaultSelectArr, option = defaultOption): string {
  if (curLang) return curLang;
  const lang = getLangFlag(selectArr, option);
  curLang = lang;
  return curLang;
}

/**
 * 获取默认规则转换后的语言标识
 * @returns 语言标记，如 zh-hk、en
 */
function getLanguage(): string {
  return getLang();
}

/** 判断是否为英文环境 */
function isEn(): boolean {
  return getLanguage() === 'en';
}

export { setLanguage, getLanguage, isEn, getOriginLang };
